module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/isologotipo_c_una_tinta-3ffe805beecb27d4f2fb57162f9cf82c.svg";